import React from 'react';
import Home from '../pages/Home';
import Collections from '../pages/Collections';
import Console from '../pages/Console';
import OidCheck from '../pages/OidCheck';
import SkillMarket from '../pages/SkillMarket';
import SkillDetail from '../pages/SkillMarket/SkillDetail';
import PluginMarket from '../pages/PluginMarket';
import PluginDetail from '../pages/PluginMarket/SkillDetail';
import Statistics from './statistics';
import orgRoutes from './exospheres';
import TNE2nd from './tne2nd';
import TNE2ndMobile from './mobile';
import pkgRoutes from './package';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import versionAll from './version-all';
import IuapVersionControl from './IuapVersionControl';
import ExperienceApply from '../pages/ExperienceApply';
import ExperienceAudit from '../pages/ExperienceAudit';

const Routes = (props: any) => {
    return (
        <Router {...props}>
            <Switch>
                <Route exact path="/">
                    <Redirect to="/skill-market"/>
                </Route>
                <Route path="/home" component={Home}/>
                <Route exact path="/skill-market" component={SkillMarket}/>
                <Route exact path="/plugin-market" component={PluginMarket}/>
                <Route exact path="/skill-market/list">
                    <Redirect to="/skill-market"/>
                </Route>
                <Route path="/skill-market/detail/:name" component={SkillDetail}/>
                <Route path="/plugin-market/detail/:name" component={PluginDetail}/>
                <Route path="/package" component={pkgRoutes}/>
                <Route path="/console" component={Console}/>
                <Route path="/oid-check" component={OidCheck}/>
                <Route path="/statistics" component={Statistics}/>
                <Route path="/tne2nd" component={TNE2nd}/>
                <Route path="/tne2nd-mobile" component={TNE2ndMobile}/>
                <Route path="/version-all" component={versionAll}/>
                <Route path="/tne3rd" component={IuapVersionControl}/>
                <Route path="/experience-apply" component={ExperienceApply}/>
                <Route path="/experience-audit" component={ExperienceAudit}/>
                <Route path="*" component={Home}/>
            </Switch>
    </Router>
  )
}
export default Routes
